import { condicaoPorExtenso, ordenarPorPrazo } from './condicaoPorExtenso'
import type { CondicaoPagamento, TabelaPreco } from '../db/tipos'

// Condicao ligada a tabela (spec 27/09, Parte 2). Vazio = vale para qualquer
// condicao. Id de condicao apagada e ignorado AQUI, na leitura -- assim
// excluir uma condicao nao obriga a regravar as tabelas, e a tabela ligada so
// a ela volta a valer para tudo sozinha.
export function condicoesValidasVivas(
  validas: readonly string[] | undefined, condicoesDaFornecedora: readonly CondicaoPagamento[],
): CondicaoPagamento[] {
  const ids = new Set(validas ?? [])
  if (ids.size === 0) return []
  return ordenarPorPrazo(condicoesDaFornecedora.filter((c) => c.apagado_em === null && ids.has(c.id)), (c) => c.descricao)
}

// Etiqueta dos "Prazos" do card da tabela (pedido dela, 28/09): o mesmo por
// extenso do card da condicao.
export function rotuloCurtoDaCondicao(descricao: string): string {
  return condicaoPorExtenso(descricao) ?? descricao
}

export function textoValeEm(validas: readonly CondicaoPagamento[]): string | null {
  return validas.length === 0 ? null : `Vale em: ${validas.map((c) => c.descricao).join(', ')}`
}

// AVISO, nunca bloqueio (escolha dela, 27/09). Calculado na hora; nao grava.
export function avisoCondicaoDaTabela(
  tabela: Pick<TabelaPreco, 'nome' | 'condicoes_validas'> | undefined,
  condicaoId: string | null,
  condicoesDaFornecedora: readonly CondicaoPagamento[],
): string | null {
  if (!tabela || !condicaoId) return null
  const validas = condicoesValidasVivas(tabela.condicoes_validas, condicoesDaFornecedora)
  if (validas.length === 0 || validas.some((c) => c.id === condicaoId)) return null
  return `A tabela ${tabela.nome} vale só em: ${validas.map((c) => c.descricao).join(', ')}.`
}
